import { Extension } from '@tiptap/core';

import { IndentProps, updateIndentLevel } from './utils';

declare module '@tiptap/core' {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Commands<ReturnType> {
    indent: {
      indent: () => ReturnType;
      outdent: () => ReturnType;
    };
  }
}

const Indent = Extension.create({
  name: 'indent',

  addOptions() {
    return {
      types: ['heading', 'paragraph'],
      indentLevels: [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330],
      defaultIndentLevel: 0,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: this.options.defaultIndentLevel,
            renderHTML: (attributes) => ({
              style: `margin-left: ${attributes.indent}px!important;`,
            }),
            parseHTML: (element) =>
              parseInt(element.style.marginLeft) ||
              this.options.defaultIndentLevel,
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      indent:
        () =>
        ({ dispatch, editor, state, tr }) => {
          const { selection } = state;
          tr = tr.setSelection(selection);
          tr = updateIndentLevel(tr, IndentProps.more);

          if (tr.docChanged && dispatch) {
            dispatch(tr);
          }

          return editor.chain().focus().run();
        },
      outdent:
        () =>
        ({ dispatch, editor, state, tr }) => {
          const { selection } = state;
          tr = tr.setSelection(selection);
          tr = updateIndentLevel(tr, IndentProps.less);

          if (tr.docChanged && dispatch) {
            dispatch(tr);
          }
          return editor.chain().focus().run();
        },
    };
  },
  // addKeyboardShortcuts() {
  //   return {
  //     Tab: () => {
  //       if (
  //         !(
  //           this.editor.isActive('bulletList') ||
  //           this.editor.isActive('orderedList')
  //         )
  //       )
  //         return this.editor.commands.indent();
  //     },
  //     'Shift-Tab': () => {
  //       if (
  //         !(
  //           this.editor.isActive('bulletList') ||
  //           this.editor.isActive('orderedList')
  //         )
  //       )
  //         return this.editor.commands.outdent();
  //     },
  //     Backspace: () => {
  //       if (
  //         !(
  //           this.editor.isActive('bulletList') ||
  //           this.editor.isActive('orderedList')
  //         )
  //       )
  //         return this.editor.commands.outdent();
  //     },
  //   };
  // },
});

export default Indent;
